import { API_PDC_URL_V2, API_PDC_URL_V3 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";

import moment from "moment";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { getQueryString } from "../../services/rest-api-call";
import { uploadDocuments } from "../documents/upload";
import { overflowNotificationConstants } from "../overflowNotification";

export const companyConstants = {
  GET_DEADLINES_START: "GET_DEADLINES_START",
  GET_DEADLINES_SUCCESS: "GET_DEADLINES_SUCCESS",
  GET_DEADLINES_ERROR: "GET_DEADLINES_ERROR",

  GET_DEADLINES_GROUPING_BY_SCOPE_START: "GET_DEADLINES_GROUPING_BY_SCOPE_START",
  GET_DEADLINES_GROUPING_BY_SCOPE_SUCCESS: "GET_DEADLINES_GROUPING_BY_SCOPE_SUCCESS",
  GET_DEADLINES_GROUPING_BY_SCOPE_ERROR: "GET_DEADLINES_GROUPING_BY_SCOPE_ERROR",

  CREATE_DEADLINES_START: "CREATE_DEADLINES_START",
  CREATE_DEADLINES_SUCCESS: "CREATE_DEADLINES_SUCCESS",
  CREATE_DEADLINES_ERROR: "CREATE_DEADLINES_ERROR",
  CREATE_DEADLINES_RESET: "CREATE_DEADLINES_RESET",

  SET_DEADLINES_ARCHIVED_START: "SET_DEADLINES_ARCHIVED_START",
  SET_DEADLINES_ARCHIVED_SUCCESS: "SET_DEADLINES_ARCHIVED_SUCCESS",
  SET_DEADLINES_ARCHIVED_ERROR: "SET_DEADLINES_ARCHIVED_ERROR",

  DELETE_DEADLINES_START: "DELETE_DEADLINES_START",
  DELETE_DEADLINES_SUCCESS: "DELETE_DEADLINES_SUCCESS",
  DELETE_DEADLINES_ERROR: "DELETE_DEADLINES_ERROR",

  GET_DEADLINES_MONTH_START: "GET_DEADLINES_MONTH_START",
  GET_DEADLINES_MONTH_SUCCESS: "GET_DEADLINES_MONTH_SUCCESS",
  GET_DEADLINES_MONTH_ERROR: "GET_DEADLINES_MONTH_ERROR",

  MODIFIED_DEADLINES_START: "MODIFIED_DEADLINES_START",
  MODIFIED_DEADLINES_SUCCESS: "MODIFIED_DEADLINES_SUCCESS",
  MODIFIED_DEADLINES_ERROR: "MODIFIED_DEADLINES_ERROR",

  REMOVE_DEADLINES_TO_LIST: "REMOVE_DEADLINES_TO_LIST",

  CLEAR_DEADLINES_LIST: "CLEAR_DEADLINES_LIST"
};

/**
 * Restituisce la lista di scadenze secondo i filtri impostati
 *
 * @param {object} isSaveFilter: serve a salvare i filtri, se carico il widget non è necessario
 * @param {string} managerId
 * @param {string} itemId
 * @param {string} fromDate
 * @param {string} toDate
 * @param {number} first i primi n-1 elementi esempio se voglio 5 elementi first sarà 6
 * @param {number} after l'indice da cui partire se voglio gli elementi dall'inizio 0 altrimenti se voglio i prossimi n-1 elemeni dopo il 10° vale 9
 * @param {string} scope
 * @param {string | array} status array per concatenare i filtri di tipo status di pagamento
 * @param {boolean} includeArchived
 */
export function getDeadlines(
  isSaveFilter, isRefresh, fromDateNormal, toDateNormal, sameAttachmentsAs=null, 
  counterpartDescription=null,  first = null, after = null, 
  scope = null, status = null, includeArchived = false, confirmed, 
  paymentMode = null, paymentType=null, nextUrl=null, expired=null
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const managerUuid = main.accountantUuidSelected;
    const itemUuid = main.companyUuidSelected;

    var archived = false; // show only not-archived deadlines (default)
    if (includeArchived) {
      archived = includeArchived;
    }

    /** inserisco il datetime perchè si è deciso che l'api vuole un datetime per
     * permettere anche agli usurai più spietati il settaggio di scadenza a orari
     * precisi
     */
    
    let fromDate = fromDateNormal ? moment(fromDateNormal + " 00:00:00").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null;
    let toDate = toDateNormal ? moment(toDateNormal + " 23:59:59").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null;

    const params = {
      managerId: managerUuid,
      itemId: itemUuid,
      fromDate: fromDate,
      toDate: toDate,
      first: first,
      after: after,
      scope:scope,
      sameAttachmentsAs: sameAttachmentsAs,
      paymentStep: status,
      paymentMode: paymentMode,
      paymentType: paymentType,
      archived: archived,
      confirmed: confirmed,
      counterpartDescription: counterpartDescription,
      expired: expired
    };

    let newParams = getQueryString(params);
    newParams = newParams !== "" ? `?${newParams}` : "";

    return new Promise(function(resolve, reject) {
      dispatch({
        type: companyConstants.GET_DEADLINES_START
      });

      let request = {
        method: "GET",
        url: nextUrl && !isRefresh ? nextUrl : API_PDC_URL_V3 + "/deadlines" + newParams,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {          
          dispatch({
            type: companyConstants.GET_DEADLINES_SUCCESS,
            payload: {
              ...response.data,
              isRefresh: isRefresh,
              isSaveFilter:isSaveFilter,
              queryParameters: {     
                sameAttachmentsAs: sameAttachmentsAs,  
                counterpartDescription: counterpartDescription,         
                fromDate: fromDate,
                toDate: toDate,
                archived: archived,
                confirmed: confirmed,
                scope: scope,
                paymentStep: status,
                paymentMode: paymentMode,
                paymentType: paymentType
              } 
            }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: companyConstants.GET_DEADLINES_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}

export function getDeadlinesMonth(
  fromDateNormal, toDateNormal, first = null, after = null, scope = null, status = null, includeArchived = false, confirmed
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const managerUuid = main.accountantUuidSelected;
    const itemUuid = main.companyUuidSelected;

    var archived = false; // show only not-archived deadlines (default)
    if (includeArchived) {
      archived = includeArchived;
    }

    /** inserisco il datetime perchè si è deciso che l'api vuole un datetime per
     * permettere anche agli usurai più spietati il settaggio di scadenza a orari
     * precisi
     */
    let fromDate = fromDateNormal ? moment(fromDateNormal + " 00:00:00").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null;
    let toDate = toDateNormal ? moment(toDateNormal + " 23:59:59").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null;

    const params = {
      managerId: managerUuid,
      itemId: itemUuid,
      fromDate,
      toDate,
      first,
      after,
      scope,
      paymentStep: status,
      archived,
      confirmed
    };

    let newParams = getQueryString(params);
    newParams = newParams !== "" ? `?${newParams}` : "";

    return new Promise(function(resolve, reject) {
      dispatch({
        type: companyConstants.GET_DEADLINES_MONTH_START
      });

      let request = {
        method: "GET",
        url: API_PDC_URL_V3 + "/deadlines" + newParams,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: companyConstants.GET_DEADLINES_MONTH_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: companyConstants.GET_DEADLINES_MONTH_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}

const reduceResponse = (array) => {
  var helper = {};
  var result = array.reduce(function(r, o) {
    var key = o.type + "-" + o.date;
  
    if (!helper[key]) {
      helper[key] = Object.assign({}, o); // create a copy of o
      r.push(helper[key]);
    } else {
      helper[key].count += o.count;
    }

    return r;
  }, []);
  return result;
};

/**
 * Restituisce le scadenze da oggi, raggruppate per data , scope e tipo
 *
 * @param {string} managerId
 * @param {string} limit numero massimo di gruppi
 * @param {string} scopes regime fiscale per cui si vogliono filtrare le scadenze
 */
// http://localhost:7071/api/v4/deadlines/statistics/group_by_scope?managerId=09387823405&limit=10&scopes=fiscal_social_security
export function getDeadlinesGroupingByScope(limit, scopes) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const managerUuid = main.accountantUuidSelected;

    const params = {
      managerId: managerUuid,
      limit,
      scopes
    };

    const additionalHeaders = {
      "X-Manager-ID": managerUuid
    };

    let newParams = getQueryString(params);
    newParams = newParams !== "" ? `?${newParams}` : "";

    return new Promise(function(resolve, reject) {
      dispatch({
        type: companyConstants.GET_DEADLINES_GROUPING_BY_SCOPE_START
      });

      let request = {
        method: "GET",
        url: API_PDC_URL_V3 + "/deadlines/groupByScope" + newParams,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          const responseReduced = reduceResponse(response?.data?._embedded?.deadlines);
          dispatch({
            type: companyConstants.GET_DEADLINES_GROUPING_BY_SCOPE_SUCCESS,
            payload: { ...response?.data?._embedded, deadlines: responseReduced}
          });
          resolve({ ...response?.data?._embedded, deadlines: responseReduced});
        })
        .catch((err) => {
          dispatch({
            type: companyConstants.GET_DEADLINES_GROUPING_BY_SCOPE_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}

/**
 * @param {object} bodyRequest
 * @param {boolean} inReconciliation
 */
export function createDeadlines(bodyRequest, inReconciliation = false) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const managerId = main.accountantIdSelected;
    const itemId = main.clientIdSelected;

    const additionalHeaders = {
      "X-Manager-ID": managerId,
      "X-Item-ID": itemId
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: companyConstants.CREATE_DEADLINES_START
      });
      let request = {
        method: "POST",
        url: API_PDC_URL_V2 + "/deadlines",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: bodyRequest
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: companyConstants.CREATE_DEADLINES_SUCCESS,
            payload: response.data
          });
          if (!inReconciliation) {
            dispatch({
              type: overflowNotificationConstants.SHOW_OVERFLOW,
              payload: {
                type: "success",
                title: "OK",
                message: "Scadenza creata con successo"
              }
            });
          }
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: companyConstants.CREATE_DEADLINES_ERROR,
            payload: { error: err }
          });
          dispatch({
            type: overflowNotificationConstants.SHOW_OVERFLOW,
            payload: {
              type: "error",
              title: "",
              message: "Errore durante la creazione della scadenza"
            }
          });
          reject();
        });
    });
  };
}

export function createDeadlinesReset() {
  return dispatch => {
    dispatch({
      type: companyConstants.CREATE_DEADLINES_RESET
    });
  };
}

export function createDeadlineWithUpload(
  uploadedDocuments, requestBody, docs, onSave
) {
  return (dispatch, getState) => {
    const main = getState().main;
    const myType = main.myType;
    const clientIdSelected = main.clientIdSelected;
    const accountantIdSelected = main.accountantIdSelected;
    const company = getState().company;

    return new Promise(function() {
      let sender = "";
      let recipient = "";
      if (myType === "STUDIO") {
        sender = accountantIdSelected;
        recipient = clientIdSelected;
      } else {
        sender = clientIdSelected;
        recipient = accountantIdSelected;
      }
      let selectedCompany = company.companies.find((el) => {
        return el.id === clientIdSelected;
      });
      let newDocumentSelected = [];
      dispatch(uploadDocuments(
        sender,
        selectedCompany.partitaIva,
        uploadedDocuments,
        0, // categoria di default,
        recipient,
        null, // note,
        [], // metadata,
        selectedCompany.codiceFiscale,
        "WEB",
        false, // da proteggere false di default,
        myType,
        false /* visibile solo allo studio false di default*/
      ))
        .then((res) => {          
          const documents = getState().documents;
          let documentSelected = [];
          for (let doc in docs) {
            if (docs.hasOwnProperty(doc)) {
              documentSelected.push({
                appId: "DBX",
                featureCode: "CORE",
                id: docs[doc].documentId
              });
            }
          }
          
          const uploadedDocumentsIds = documents?.upload?.uploadedSingleDocument?.documents ? [...documents?.upload?.uploadedSingleDocument?.documents] : [];
          for (let item in uploadedDocumentsIds) {
            if (uploadedDocumentsIds.hasOwnProperty(item)) {
              newDocumentSelected.push({
                appId: "DBX",
                featureCode: "CORE",
                id: uploadedDocumentsIds[item]
              });
            }
          }
          requestBody.attachments = [...documentSelected, ...newDocumentSelected];
          
          dispatch(onSave(requestBody));
        })
        .catch((err) => {
          dispatch({
            type: companyConstants.CREATE_DEADLINES_ERROR,
            payload: { error: err }
          });
        });
    });
  };
}

/**
 *
 * @param {object} auth
 * @param {string} managerId
 * @param {string} itemId
 * @param {object} deadline
 * @param {*} onSuccessCallback
 * @param {boolean} showArchived
 */
export function toggleArchivedDeadline(
  deadline, onSuccessCallback, showArchived
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const managerId = main.accountantIdSelected;
    const itemId = main.clientIdSelected;

    const additionalHeaders = {
      "X-Manager-ID": managerId,
      "X-Item-ID": itemId
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: companyConstants.SET_DEADLINES_ARCHIVED_START
      });

      const value = !deadline.status.archived;

      let request = {
        method: "PATCH",
        url: API_PDC_URL_V2 + "/deadlines/" + deadline.id + "/archive/" + value,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: companyConstants.SET_DEADLINES_ARCHIVED_SUCCESS,
            payload: {
              id: response.data.id,
              archived: value,
              showArchived: showArchived === null ? null : false
            }
          });
          resolve(response.data);
          if (onSuccessCallback) {
            onSuccessCallback();
          }
        })
        .catch((err) => {
          dispatch({
            type: companyConstants.SET_DEADLINES_ARCHIVED_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}

export function removeDeadlinesFromList(deadlines) {
  return (dispatch) => {
    dispatch({
      type: companyConstants.REMOVE_DEADLINES_TO_LIST,
      payload: deadlines
    });
  };
}

export function clearDeadlinesFromList() {
  return (dispatch) => {
    dispatch({
      type: companyConstants.CLEAR_DEADLINES_LIST
    });
  };
}
